"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Table = _interopRequireDefault(require("react-rainbow-components/components/Table"));

var _firebaseHooks = require("@rainbow-modules/firebase-hooks");

var _getQuery = _interopRequireDefault(require("./getQuery"));

var FirestoreTableFetchOnce = function FirestoreTableFetchOnce(props) {
  var children = props.children,
      collection = props.collection,
      query = props.query,
      defaultSortDirection = props.defaultSortDirection,
      sortedBy = props.sortedBy,
      rest = (0, _objectWithoutProperties2["default"])(props, ["children", "collection", "query", "defaultSortDirection", "sortedBy"]);

  var _useState = (0, _react.useState)(defaultSortDirection),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      sortDirection = _useState2[0],
      setSortDirection = _useState2[1];

  var _useCollectionOnce = (0, _firebaseHooks.useCollectionOnce)({
    path: collection,
    query: (0, _getQuery["default"])({
      query: query,
      sortedBy: sortedBy,
      sortDirection: sortDirection
    }),
    flat: true
  }),
      _useCollectionOnce2 = (0, _slicedToArray2["default"])(_useCollectionOnce, 2),
      data = _useCollectionOnce2[0],
      isLoading = _useCollectionOnce2[1];

  var handleSort = function handleSort(event, field, nextSortDirection) {
    setSortDirection(nextSortDirection);
  };

  return /*#__PURE__*/_react["default"].createElement(_Table["default"], (0, _extends2["default"])({}, rest, {
    keyField: "id",
    data: data,
    isLoading: isLoading,
    onSort: handleSort,
    sortDirection: sortDirection,
    sortedBy: sortedBy
  }), children);
};

FirestoreTableFetchOnce.propTypes = {
  collection: _propTypes["default"].string.isRequired,
  query: _propTypes["default"].func,
  defaultSortDirection: _propTypes["default"].oneOf(['asc', 'desc']),
  sortedBy: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].object])
};
FirestoreTableFetchOnce.defaultProps = {
  query: undefined,
  defaultSortDirection: 'asc',
  sortedBy: undefined,
  children: []
};
var _default = FirestoreTableFetchOnce;
exports["default"] = _default;